<template>
  <!--角色管理 -->
  <div class="newsPage">
    <div>
      <el-card style="margin: 30px">
        <div style="display: flex;align-items: center">
          <div>审核状态：</div>
          <el-select v-model="examineStatus" size="small" style="width: 180px;margin-right: 10px" clearable placeholder="请选择审核状态">
            <el-option
                v-for="item in [{'key':0,'value':'待审核'},{'key':1,'value':'审核通过'},{'key':2,'value':'审核未通过'},{'key':3,'value':'已下架'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
          <div>话题标题：</div>
          <el-input clearable placeholder="请输入搜索内容" size="small" style="width: 180px;margin-right: 10px" v-model="topicTitle"></el-input>
          <div>创建时间：</div>
          <el-date-picker
              v-model="dateValue"
              :clearable="false"
              @change="dateChange"
              type="daterange"
              size="small"
              style="margin-right: 10px"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
        </div>

        <div style="display: flex;align-items: center;margin-top: 30px">
          <div>是否热点：</div>
          <el-select v-model="isHotspot" size="small" style="width: 180px;margin-right: 10px" clearable placeholder="请选择">
            <el-option
                v-for="item in [{'key':1,'value':'是'},{'key':0,'value':'否'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
          <el-button @click="searchBtn" type="primary" size="small">查询</el-button>
          <el-button size="small" type="danger" @click="resetBtn">重置</el-button>
          <el-button v-if="auditBatchList&&auditBatchList.length" @click="auditBatchBtn" size="small" type="danger">批量审核</el-button>
          <el-button v-if="takeDownIds&&takeDownIds.length" @click="takeDownBatchBtn" size="small" type="danger">批量下架</el-button>
          <el-button v-if="multipleSelection&&multipleSelection.length" @click="batchDeleteBtn" size="small" type="danger">批量删除</el-button>
        </div>
        <el-table
            size="small"
            ref="multipleTable"
            tooltip-effect="dark"
            :data="tableData"
            @selection-change="handleSelectionChange"
            border
            style="width: 100%;margin-top: 30px"
        >
          <el-table-column
              type="selection"
              align="center"
              width="55">
          </el-table-column>
          <el-table-column label="话题标题" width="230" align="center">
            <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{scope.row.topic_title}}
                </template>
                <span style="width:210px;height:40px;display: -webkit-box;-webkit-box-orient: vertical;text-overflow: ellipsis;-webkit-line-clamp: 2;overflow : hidden;">{{ scope.row.topic_title }}</span>
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="摘要" width="230" align="center">
            <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{scope.row.abstract}}
                </template>
                <span style="width:210px;height:40px;display: -webkit-box;-webkit-box-orient: vertical;text-overflow: ellipsis;-webkit-line-clamp: 2;overflow : hidden;">{{ scope.row.abstract }}</span>
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="封面图" align="center">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: center">
                <el-image
                    style="width: 160px; height: 80px"
                    :src="scope.row.cover_url"
                    :preview-src-list="scope.row.cover_urlList">
                </el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="背景图" align="center">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: center">
                <el-image
                    style="width: 160px; height: 80px"
                    :src="scope.row.background_url"
                    :preview-src-list="scope.row.background_urlList">
                </el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="参与人数" width="80" prop="participate_count" align="center"></el-table-column>
          <el-table-column label="阅读人数" width="80" prop="read_count" align="center"></el-table-column>
          <el-table-column label="是否热点" width="80" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.is_hotspot === 0 ? '否':'是' }}</div>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="120" align="center">
            <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{scope.row.create_date}}
                </template>
                {{ scope.row.create_date_list[0] }}
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column header-align="center" width="120" label="审核状态">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: center">
                <el-tag type="warning" size="small" effect="dark" v-if="scope.row.examine_status === 0">待审核</el-tag>
                <el-tag type="success" size="small" effect="dark" v-else-if="scope.row.examine_status === 1">审核通过</el-tag>
                <el-tag type="danger" size="small" effect="dark" v-else-if="scope.row.examine_status === 2">审核未通过</el-tag>
                <el-tag type="info" size="small" effect="dark" v-else-if="scope.row.examine_status === 3">已下架</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              label="操作"
              width="300"
          >
            <template slot-scope="scope">
              <el-button @click="auditBtn(scope.row)" v-if="scope.row.examine_status === 0" size="small" type="success">审核</el-button>
              <el-button @click="editBtn(scope.row)" size="small" type="success">修改</el-button>
              <el-button @click="takeDownBtn(scope.row)" v-if="scope.row.examine_status === 1" size="small" type="danger">下架</el-button>
              <el-button @click="deleteBtn(scope.row)" size="small" type="danger">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="display: flex;justify-content: center;margin-top: 20px"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[20, 30, 40, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElements">
        </el-pagination>
      </el-card>
    </div>
    <!--    删除的弹窗-->
    <a-modal
        title="提示"
        :visible="deleteDialogState"
        cancel-text="取消"
        ok-text="确认"
        width="400px"
        @cancel="deleteCancel"
        @ok="deleteSubmit"
    >
      <div>{{simpleDelete?'是否删除该条记录？':'是否删除当前所选中的记录？'}}</div>
    </a-modal>

    <a-modal
        :visible="editDialogState"
        cancel-text="取消"
        ok-text="确认"
        title="修改"
        width="400px"
        @cancel="editCancel"
        @ok="editSubmit('editRuleForm')"
    >
      <el-form
          ref="editRuleForm"
          :model="editRuleForm"
          class="small-space"
          label-position="right"
          label-width="100px"
      >
        <el-form-item label="阅读人数">
          <el-input-number :min="0" v-model="editRuleForm.readCount"></el-input-number>
        </el-form-item>
        <el-form-item label="参与人数">
          <el-input-number :min="0" v-model="editRuleForm.participateCount" :max="editRuleForm.readCount"></el-input-number>
        </el-form-item>
        <el-form-item label="是否热点">
          <el-select style="width: 180px" v-model="editRuleForm.isHotspot" placeholder="请选择">
            <el-option
                v-for="item in [{key:0,value:'否'},{key:1,value: '是'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </a-modal>

    <!--    审核的弹窗-->
    <a-modal
        :visible="auditDialogState"
        cancel-text="取消"
        ok-text="确认"
        title="审核"
        width="400px"
        @cancel="auditCancel"
        @ok="auditSubmit('auditRuleForm')"
    >
      <el-form
          ref="auditRuleForm"
          :model="auditRuleForm"
          :rules="auditRules"
          class="small-space"
          label-position="right"
          label-width="100px"
      >
        <el-form-item label="审核状态" prop="examineStatus">
          <el-select v-model="auditRuleForm.examineStatus" size="small" style="width: 180px;margin-right: 10px" clearable placeholder="请选择审核状态">
            <el-option
                v-for="item in [{'key':1,'value':'审核通过'},{'key':2,'value':'审核未通过'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </a-modal>


    <!--    下架的弹窗-->
    <a-modal
        title="提示"
        :visible="takeDownDialogState"
        cancel-text="取消"
        ok-text="确认"
        width="400px"
        @cancel="takeDownCancel"
        @ok="takeDownSubmit"
    >
      <div>{{simpleTakeDown?'是否下架该话题？':'是否下架当前所选中的话题？'}}</div>
    </a-modal>


  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      pageNum: 1,
      pageSize: 20,
      examineStatus:null,
      topicTitle:'',
      sortType:null,
      isHotspot:null,
      dateValue:'',
      createStartDate:'',
      createEndDate:'',
      tableData:[],
      totalElements: 0,//数据总数
      multipleSelection:[],
      auditBatchList:[],
      takeDownIds:[],
      deleteDialogState:false,
      deleteId:'',
      simpleDelete:false,//是单个删除还是多个删除
      auditDialogState:false,
      auditRuleForm:{
        examineStatus:null
      },
      auditRules:{
        examineStatus: [{required: true, message: "请选择审核状态", trigger: "blur"}],
      },
      simpleAudit:false,
      auditId:'',
      editDialogState:false,
      editRuleForm:{
        id:'',
        participateCount:0,
        readCount:0,
        isHotspot:null,
      },

      takeDownDialogState:false,
      simpleTakeDown:false,
      takeDownId:''
    };
  },
  methods: {
    searchBtn() {
      this.pageNum = 1
      this.pageSize = 20
      this.getNewsList()
    },
    resetBtn() {
      this.pageNum = 1
      this.pageSize = 20
      this.examineStatus = null
      this.sortType = null
      this.isHotspot = null
      this.topicTitle = ''
      this.createStartDate = ''
      this.createEndDate = ''
      this.dateValue = ''
      this.getNewsList()
    },
    dateChange(e){
      this.dateValue = e
      this.createStartDate = moment(this.dateValue[0]).format('YYYY-MM-DD')
      this.createEndDate = moment(this.dateValue[1]).format('YYYY-MM-DD')
    },
    editBtn(row){
      this.editRuleForm.id = row.id
      this.editRuleForm.participateCount = row.participate_count
      this.editRuleForm.readCount = row.read_count
      this.editRuleForm.isHotspot = row.is_hotspot ? row.is_hotspot : row.is_hotspot === 0 ? row.is_hotspot :null
      this.editDialogState = true
    },
    takeDownBtn(row){
      this.simpleTakeDown = true
      this.takeDownId = row.id
      this.takeDownDialogState = true
    },
    deleteBtn(row){
      this.simpleDelete = true
      this.deleteId = row.id
      this.deleteDialogState = true
    },
    takeDownCancel(){
      this.takeDownDialogState = false
    },
    takeDownSubmit(){
      if (this.simpleTakeDown){
        //单个下架
        this.postAxios("/topic/updTopicShelfByIds", {
          examineStatus:3,
          ids:[this.takeDownId]
        }).then(res=>{
          if (res.success){
            this.$message.success("下架成功!")
            this.takeDownId = ''
            this.takeDownDialogState = false
            this.getNewsList()
          }
        })
      }else{
        //多个下架
        this.postAxios("/topic/updTopicShelfByIds",{
          examineStatus:3,
          ids:this.takeDownIds
        }).then(res => {
          if (res.success) {
            this.$message.success("已下架" + this.takeDownIds.length + '条数据!')
            this.takeDownDialogState = false
            this.getNewsList()
          }
        });
      }
    },
    auditBtn(row){
      this.simpleAudit = true
      this.auditId = row.id
      this.auditRuleForm.examineStatus = 1
      this.auditDialogState = true
    },
    batchDeleteBtn(){
      this.simpleDelete = false
      this.auditRuleForm.examineStatus = null
      this.deleteDialogState = true
    },
    auditBatchBtn(){
      this.auditRuleForm.examineStatus = 1
      this.simpleAudit = false
      this.auditDialogState = true
    },
    takeDownBatchBtn(){
      this.simpleTakeDown = false
      this.takeDownDialogState = true
    },
    deleteCancel(){
      this.deleteDialogState = false
    },
    auditCancel(){
      this.auditDialogState = false
    },
    editCancel() {
      this.editDialogState = false
    },
    editSubmit(formName){
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.postAxios("/topic/updTopicStatusById", this.editRuleForm).then(res=>{
            if (res.success){
              this.$message.success(res.message)
              this.editDialogState = false
              this.getNewsList()
            }
          })
        }
      });
    },
    auditSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.simpleAudit){
            this.postAxios("/topic/updTopicExamineStatusById", {
              examineStatus:this.auditRuleForm.examineStatus,
              idList:[this.auditId]
            }).then(res=>{
              if (res.success){
                this.$message.success(res.message)
                this.auditId = ''
                this.auditDialogState = false
                this.getNewsList()
              }
            })
          }else{
            this.postAxios("/topic/updTopicExamineStatusById", {
              examineStatus:this.auditRuleForm.examineStatus,
              idList:this.auditBatchList
            }).then(res=>{
              if (res.success){
                this.$message.success(res.message)
                this.auditBatchList = []
                this.multipleSelection = []
                this.auditDialogState = false
                this.getNewsList()
              }
            })
          }
        }
      });
    },
    deleteSubmit(){
      if (this.simpleDelete){
        //单个删除
        this.postAxios("/topic/delTopicByIdsForBackgroundReviewer", [
          this.deleteId
        ]).then(res=>{
          if (res.success){
            this.$message.success(res.message)
            this.deleteId = ''
            this.deleteDialogState = false
            this.getNewsList()
          }
        })
      }else{
        //多个删除
        let ids = []
        this.multipleSelection.forEach((item)=>{
          ids.push(item.id)
        })
        this.postAxios("/topic/delTopicByIdsForBackgroundReviewer", ids).then(res=>{
          if (res.success){
            this.$message.success(res.message)
            this.deleteId = ''
            this.deleteDialogState = false
            this.getNewsList()
          }
        })
      }
    },
    //用户列表
    getNewsList() {
      this.postAxios("/topic/selTopicForBackgroundReviewer", {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        parameterMap: {
          examineStatus: this.examineStatus ? this.examineStatus : this.examineStatus === 0 ? this.examineStatus :null,
          topicTitle: this.topicTitle,
          createStartDate: this.createStartDate,
          createEndDate: this.createEndDate,
          sortType:this.sortType?this.sortType:null,
          isHotspot:this.isHotspot ? this.isHotspot : this.isHotspot === 0 ? this.isHotspot : null,
        }
      }).then(res => {
        if (res.success) {
          this.tableData = []
          this.tableData = res.content;
          this.tableData.forEach((item)=>{
            item.create_date_list = item.create_date.split(' ')
            item.cover_urlList = []
            item.background_urlList = []
            if (item.cover_url){
              item.cover_urlList.push(item.cover_url)
            }
            if (item.background_url){
              item.background_urlList.push(item.background_url)
            }
          })
          this.totalElements = res.totalCount
        } else {
          this.tableData = []
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.auditBatchList = []
      this.takeDownIds = []
      if (this.multipleSelection&&this.multipleSelection.length){
        this.multipleSelection.forEach((item)=>{
          if (item.examine_status === 0){
            this.auditBatchList.push(item.id)
          }else if (item.examine_status === 1){
            this.takeDownIds.push(item.id)
          }
        })
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getNewsList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getNewsList()
    }
  },
  created() {
    this.getNewsList(); //用户的列表
  }
};
</script>
<style lang="less" scoped>
</style>
